// Phase 10 — global socket-status banner.
//
// Sits below the auth-expired banner. Surfaces the singleton socket's
// state so users know when realtime updates are stale.

import { useSocketStatus } from '@/hooks/useSocketStatus';

export function SocketStatusBanner() {
  const s = useSocketStatus();
  if (s.status === 'connected' || s.status === 'disconnected') return null;

  const isReconnecting = s.status === 'reconnecting';
  const tone = isReconnecting ? 'bg-blue-500/95 text-blue-50' : 'bg-orange-500/95 text-orange-950';
  const label = isReconnecting
    ? `Reconnecting to realtime updates… (attempt ${s.reconnectAttempts})`
    : 'Realtime updates are offline. Some dashboard panels may be stale.';

  return (
    <div role="status" className={`fixed top-12 left-0 right-0 z-[55] ${tone} px-4 py-1.5 text-sm shadow`}>
      {label}
    </div>
  );
}
